export function dataLayerPush(object, override) {
  const dataLayer = window.dataLayer;
	if (!dataLayer) {
		window.dataLayer = [];
    console.warn("DataLayer is not present. It is likely you haven't added the google tag manager script.");
    return;
  }
  dataLayer.push(object);
  if (override) {
    localStorage.setItem('dataLayer', JSON.stringify(object));
  }
}

// Update the stored datalayer's price.
export function updateDatalayerPrice(price) {
	let object = JSON.parse(localStorage.getItem('dataLayer'));
	object.price = price;
	localStorage.setItem('dataLayer', JSON.stringify(object));
}

/**
* Populates the ecommerce object to be used by GTM.
* The impressions event is set because we are viewing the results.
*
* @param {object} searchObj 	The URL params
* @param {array} list 			List of hotels
* @return {object} 				Includes list of hotels and GA data to be set
*/
export function enhancedEcommerce(searchObj, list, typeOfObject) {
	let gaData = []
	let hotelGA; 
	if (typeOfObject === 'sovereign') {
    list.map((hotel, i) => {
      i++ // to start at 1 rather than 0
      hotelGA = {
        'id': hotel.ID,
        'name': hotel.HotelName ? hotel.HotelName : hotel.Name,
        'list': "Search Results",
        'position': i,
        'dimension41': searchObj.country,
        'dimension42': searchObj.region.replace('+', ' '),
        'dimension43': hotel.Resort,
        'dimension44': hotel.Rating,
        'dimension45': hotel.TripAdvisorRating,
        'dimension46': hotel.AccommodationAvailability.length ? hotel.AccommodationAvailability[hotel.activeIndex].Flight : '',
        'dimension47': hotel.AccommodationAvailability[hotel.activeIndex].BoardBasis,
        'dimension48': searchObj.date,
        'dimension49': searchObj.duration
      }
      gaData.push(hotelGA);

      // Set list position for the hotel in case of re-ording due to filters. Set GA data for easy re-use.
      hotel.listPosition = i;
      hotel.GA = hotelGA;
	  });
  }
  else if (typeOfObject === 'citalia') {
    list.map((hotel, i) => {
      i++ // to start at 1 rather than 0
      hotelGA = {
        'id': hotel.ID,
        'name': hotel.HotelName ? hotel.HotelName : hotel.Name,
        'list': "Search Results",
        'position': i,
        'dimension1': searchObj.country,
        'dimension2': searchObj.region.replace('+', ' '),
        'dimension3': hotel.Resort,
        'dimension4': hotel.Rating,
        'dimension5': hotel.TripAdvisorRating,
        'dimension6': hotel.AccommodationAvailability.length ? hotel.AccommodationAvailability[hotel.activeIndex].Flight : '',
        'dimension7': hotel.AccommodationAvailability[hotel.activeIndex].BoardBasis,
        'dimension8': searchObj.date,
        'dimension9': searchObj.duration
      }
      gaData.push(hotelGA);

      // Set list position for the hotel in case of re-ording due to filters. Set GA data for easy re-use.
      hotel.listPosition = i;
      hotel.GA = hotelGA;
	  });
  } 
  else if (typeOfObject === 'ga4') {
    list.map((hotel, i) => {
      i++ // to start at 1 rather than 0
      hotelGA = {
        'item_id': hotel.ID,
        'item_name': hotel.HotelName ? hotel.HotelName : hotel.Name,
        'item_brand': searchObj.region.replace('+', ' '),
        'item_category': hotel.Resort,
        'item_category4': hotel.Rating,
        'item_category5': hotel.TripAdvisorRating,
        'item_category2': hotel.AccommodationAvailability.length ? hotel.AccommodationAvailability[hotel.activeIndex].Flight : '',
        'item_category3': hotel.AccommodationAvailability[hotel.activeIndex].BoardBasis,
      }
      gaData.push(hotelGA);
      // Set list position for the hotel in case of re-ording due to filters. Set GA data for easy re-use.
      hotel.listPosition = i;
      hotel.GA4 = hotelGA;
	  });
  }

	return ({
		list,
		gaData
	})
}

/**
* Shorthand to pull hotel and query from session to create
* GA product/item objects
*
* @param {boolean} isGA4 	Whether to return for GA4 or not
* @return {object} 				Returns the result of the enhanced ecommerce function above
*/
export function getProducts(isGA4 = true) {
  const hotel = JSON.parse(sessionStorage.getItem("currentHotel"));
  const search = JSON.parse(sessionStorage.getItem("currentSearch"));
  const site = document.querySelector("html").dataset.siteName;
  return enhancedEcommerce(search, [hotel], isGA4 ? 'ga4' : site).gaData;
}